<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <error-log class="errLog-container right-menu-item hover-effect" />

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="hover"
      >
        <div class="avatar-wrapper">
          <img src="@/assets/image/menager.png" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span
              style="display: block"
            >{{ userinfo.adminInfoVo.name }}({{
              userinfo.adminInfoVo.username
            }})</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display: block">{{
              userinfo.adminInfoVo.loginIp
            }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <!-- <span>这是一段信息</span> -->
        <div>
          <el-button
            v-if="role"
            type="primary"
            size="mini"
            @click="jumoTo('/setting/role')"
          >角色分配</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog
    // Screenfull,
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device', 'userinfo', 'roles']),
    dynamicContentWordLib() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentWordLib')) {
        return true
      }
      return false
    },
    dynamicContentAutoChat() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentAutoChat')) {
        return true
      }
      return false
    },
    dynamicContentAutoMember() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:dynamicContentAutoMember')) {
        return true
      }
      return false
    },

    role() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:role')) {
        return true
      }
      return false
    },
    comment() {
      if (this.roles.includes('admin:*')) {
        return true
      }
      if (this.roles.includes('admin:comment')) {
        return true
      }
      return false
    }
  },
  data() {
    return {
      dialogVisible: false,
      time: 0,
      timer: null
    }
  },
  mounted() {
    // console.log(this.roles)
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    shabi() {
      console.log(111)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.time = 0
        clearTimeout(this.timer)
      }, 2000)
      if (this.time >= 4) {
        this.dialogVisible = true
        this.time = 0
        clearTimeout(this.timer)
      } else {
        this.time++
      }
    },
    jumoTo(url) {
      this.dialogVisible = false
      this.$router.push(`${url}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25%;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
